import Image from 'next/image';
import { useTranslation } from 'next-export-i18n';
import React from 'react';

import ActivelyFoundraising from '@/assets/fundraising.svg';

const ActivelyFundraising = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-start rounded-xl bg-yellow-100 p-5">
      <div className="mr-3 w-16">
        <Image
          src={ActivelyFoundraising}
          alt={t('company.activelyFoundraisingPortfolio')}
          objectFit="cover"
          layout="responsive"
          quality={100}
        />
      </div>
      <h4 className="text-lg font-bold md:text-lg">
        {t('company.activelyFoundraisingPortfolio')}
      </h4>
    </div>
  );
};

export default ActivelyFundraising;
